export function IntegrationContentNotice({ status, zh, onRetry }: {
  status: 'loading' | 'error' | 'missing'; zh: boolean; onRetry: () => void;
}) {
  return (
    <div role={status === 'error' ? 'alert' : 'status'} className="space-y-2 text-sm leading-6 text-[#666F8D]">
      <p>{status === 'loading'
        ? (zh ? '正在加载应用说明…' : 'Loading app details…')
        : status === 'error'
          ? (zh ? '暂时无法加载应用说明。连接状态未改变，请重试。' : 'App details could not be loaded. Your connections have not changed. Try again.')
          : (zh ? '此应用的详细说明暂不可用。' : 'Detailed information for this app is not available yet.')}</p>
      {status === 'error' ? (
        <button type="button" onClick={onRetry} className="font-medium text-[#1A162F] underline underline-offset-4">
          {zh ? '重试' : 'Try again'}
        </button>
      ) : null}
    </div>
  );
}
